import axios from "axios";

export const sendNewBusinessLocationDetailsToServer = async (functionParameters = {}) => {

    const {  submissionData, apiEndPoint, accountType, language, preloader, smetioSmartbox, smetioSlideShow } = functionParameters;

    const appClass = window.smetioApp;
    const sideMenuItems = window.currentSideMenuItems;
    const currentlyVisibleSideMenuItemName = window.currentlyVisibleSideMenuItemName;
    const smetioAppUi = window.currentSmetioAppUi;

    preloader.show();

    // console.log("This is the submission data: ", submissionData);

    // console.log("And the language is ", language);

    // console.log("And the account type is ", accountType);

    // console.log("And the side menu items are ", sideMenuItems)

    // const url = `${apiEndPoint}/businessLocations/createNew/${language}`;
    const url = `${apiEndPoint}/apps/${appClass.appUserInterface}/businessLocations/create/${language}`;
  
    const res = await axios.post(url, {
        modelPath: "loggedInUser/businessLocationModels/businessLocationModel",
        ...submissionData
    }).then(async (response) => {

        // console.log("Here is the response from createNewBusinessLocation : ",response );

        let model = response.data;

        if (model.error) return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] });

        window.smetioVisitor.showNotification({ type: "success", body: [{ message: "txt521" }] });

        const dataPresentation = model.msg;

        console.log("======= Add the new data presentation ========= ");

        // if (smetioAppUi.sideMenu.dataGroups["businessLocations"]) await smetioAppUi.sideMenu.dataGroups["businessLocations"].addNewDataPresentation(dataPresentation);
    
        sideMenuItems["businessLocations"].onClick();
    
        //     const sideMenuItems = window.currentSideMenuItems;
        // const currentlyVisibleSideMenuItemName = window.currentlyVisibleSideMenuItemName;

        smetioSmartbox.close();

    }).catch((error) => {

        console.log(error);
        return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

    }).finally(() => {
        preloader.hide();
    });
};
